import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {ActivatedRoute} from '@angular/router';
import {SessionService, User} from '../../@core/session.service';
import {Observable} from 'rxjs';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.less'],
  standalone: false
})
export class LoginPageComponent implements OnInit {

  ssoUrl = `${environment.ssoUrl}?r=${window.location.href}/`;
  user$: Observable<User>;
  form = new UntypedFormGroup({
    userId: new UntypedFormControl(null, Validators.required),
    password: new UntypedFormControl(null, Validators.required)
  });
  showPage = false;

  constructor(private actRoute: ActivatedRoute,
              private sess: SessionService) {
  }

  ngOnInit(): void {
    this.user$ = this.sess.getUser$();
    const token = this.actRoute.snapshot.params?.token;
    if (token) {
      this.sess.ssoSignIn(token);
    } else {
      this.showPage = true;
    }
  }

  signOut() {
    this.sess.signOut();
  }

  signIn() {
    if (this.form.valid) {
      const {userId, password} = this.form.value;
      this.sess.passwordSignIn(userId, password);
    }
  }

}
